import React, { useState, useEffect } from "react";
import GainIcon from "../gainicon";
import AddButton from "./AddButton";
import FilterDropdown from "./FilterDropdown";
import SearchInput from "./SearchInput";

const CardContext = React.createContext();

export default function CardTitleFilter(props) {
  const [Add, setAdd] = useState(true);

  useEffect(() => {
    if (props.add === undefined) {
      setAdd(true);
    } else {
      setAdd(props.add);
    }
  }, []);

  return (
    <CardContext.Provider
      value={{
        onSearch: props.onSearch,
        Sort: {
          options: props.filterOptions,
          onSort: props.onSort,
        },
      }}
    >
      <div className="grid grid-cols-2 items-center content-center">
        <div className="w-64">
          <SearchInput />
        </div>
        <div className="flex w-100 items-center justify-end">
          <GainIcon name="sort" />
          <div className="font-light">
            <span className="text-gray-500 ml-5">Sort by : </span>
            <FilterDropdown options={props.filterOptions} />
          </div>
          <AddButton
            label={props.addLabel}
            onClick={props.onAdd}
            hidden={Add}
          />
        </div>
      </div>
    </CardContext.Provider>
  );
}

export { CardContext };
